import { render, staticRenderFns } from "./moduleNavigator.vue?vue&type=template&id=1dcc792d&"
import script from "./moduleNavigator.vue?vue&type=script&lang=js&"
export * from "./moduleNavigator.vue?vue&type=script&lang=js&"
import style0 from "./moduleNavigator.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports